import React from "react";
import { Avatar } from "@mui/material";

const CRMAvatar = ({ initials, size = 36, color = "#1a2333" }) => (
    <Avatar
        sx={{
            width: size,
            height: size,
            backgroundColor: color,
            fontSize: size * 0.35,
            fontWeight: 700,
            flexShrink: 0,
        }}
    >
        {initials}
    </Avatar>
);

export default CRMAvatar;
